module.exports = __webpack_public_path__ + "img/Logo DC_Blanco.9d60d3d1.png";